import { render, staticRenderFns } from "./BacEditableMinioImage.vue?vue&type=template&id=5ebacf40&"
import script from "./BacEditableMinioImage.vue?vue&type=script&lang=ts&"
export * from "./BacEditableMinioImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports